import dynamic from 'next/dynamic';
import { HeaderBackButton, RightCloseBtnContainer } from './styled';
import { BackHistoryStorage } from '../../../utils/helpers/BackHistoryStorage';
import { BackButtonIconEnum } from './types';
import { CloseButton } from './CloseButton';

const BackButton = dynamic(
  () => import('../../BackButton').then(mod => mod.BackButton),
  { ssr: false }
);

export const useHeaderActions = (
  icon: BackButtonIconEnum,
  onClick?: () => void,
  backButtonCypress?: string
) => {
  const hasBack = BackHistoryStorage.getBackHistoryStorage();

  switch (icon) {
    case BackButtonIconEnum.Back:
      return {
        customLeftAction: (
          <HeaderBackButton
            data-cy={backButtonCypress}
            onClick={onClick}
            aria-label="Back"
          />
        ),
        customRightAction: null
      };
    case BackButtonIconEnum.InternalNavigationBackButton:
      return {
        customLeftAction: <BackButton />,
        customRightAction: !hasBack ? (
          <RightCloseBtnContainer>
            <CloseButton
              onClick={onClick}
              backButtonCypress={backButtonCypress}
            />
          </RightCloseBtnContainer>
        ) : null
      };
    default:
      return {
        customLeftAction: (
          <CloseButton
            onClick={onClick}
            backButtonCypress={backButtonCypress}
          />
        ),
        customRightAction: null
      };
  }
};
